<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // view -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<template>
  <div class="container">
    <h2>あなたの大切なAPPをぱんだロック！</h2>
    <div class="StatsInfoStyle">
      <div>⚫ ロックや解除にはガス代が発生します</div>
      <div>⚫ ロックするとシードフレーズや秘密鍵が盗まれないかぎり、勝手に転送されることはありません</div>
      <div>⚫ Magic Edenなどで売却する時には必ず解除しましょう</div>
    </div>

    <!-- 1. メタマスクが使えないブラウザ -->
    <template v-if="!canUseMetaMask()">
      <div>ブラウザでメタマスクが使える状態になっていません</div>
    </template>
    <!-- 2. メタマスク未接続 -->
    <template v-else-if="!connectedMetaMask()">
      <div class="connect-section">
        <div class="form-label text-body">メタマスク（メインネット）で接続してください</div>
        <button class="btn btn-primary connect-button" @click="onClickConnect">ウォレット接続する</button>
        <div v-show="networkchange" class="form-label text-danger font-weight-bold">Ethereumメインネットへの切り替えができませんでした。ウォレットでこのサイトのネットワークをEthereumメインネットにしてから、もう一度「ウォレット接続する」を押してください</div>
        <div v-show="connectError" class="form-label text-danger font-weight-bold">{{ connectError }}</div>
        <img class="locklogo" alt="PandaLock_key" src="../assets/PandaLock_key1.png">
      </div>
    </template>
    <template v-else-if="array_tokenid.length == 0">
      <div v-show="loading" class="loader">Please wait...</div>
      <dev class="form-label text-body" v-show="!loading">APPをお持ちでありません。。OpenSeaで購入してみよう！</dev>
      <a href="https://opensea.io/ja/collection/aopanda-party/" target="_blank" v-show="!loading">OpenSeaを見てみる。</a>
    </template>
    <!-- 3. その他(メタマスク接続済) -->
    <template v-else>
      <div v-show="loading" class="loader">Please wait...</div>
      <!-- メニュー切り替え -->
      <div class="btn-group btn-group-toggle" data-toggle="buttons" v-show="!loading">
        <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 1, 'btn-outline-secondary': toggled !== 1}">
          <input type="radio" name="options" id="normal" v-model="moderadio" value="normal" @change="onModeCahange()"> 個別管理
        </label>
        <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 2, 'btn-outline-secondary': toggled !== 2}">
          <input type="radio" name="options" id="batchlock" v-model="moderadio" value="batchlock" @change="onModeCahange_2()"> 一括ロック
        </label>
        <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 3, 'btn-outline-secondary': toggled !== 3}">
          <input type="radio" name="options" id="batchrelease" v-model="moderadio" value="batchrelease" @change="onModeCahange_3()"> 一括解除
        </label>
        <label class="btn btn-outline-secondary" v-bind:class="{'btn-warning font-weight-bold': toggled === 4, 'btn-outline-secondary': toggled !== 4}">
          <input type="radio" name="options" id="info" v-model="moderadio" value="info" @change="onModeCahange_4()"> ロック情報
        </label>
      </div>

      <!-- ロック/解除メイン機能 -->
      <div class="collection-detail" v-show="!loading">
        <template v-if="moderadio == 'normal'">
          <!-- 個別管理 -->
          <div v-for="(tokenid,index_token) in array_tokenid" :key="tokenid.Object" class="nft-card-wrapper">
              <img :src="array_tokenid[index_token].image" class="shadow p-1 mb-3 bg-white rounded imagebox" :id="`image${index_token}`">
              <div class="box h6">{{array_tokenid[index_token].title}}</div>
              
              <!-- チェックボックス -->
              <div class="checkbox-container">
                <input type="checkbox" v-model="lockednft[index_token]" :id="'cb' + index_token" @change="onCheckCahange()"/>
              </div>
              <div class="checkbox-label">
                <label class="h6" :for="'cb' + index_token">{{lockedchange_string[index_token]}}</label>
              </div>

              <!-- ロック設定ボタン -->
              <div v-if="lockedchange[index_token] == true">
                  <button class="btn btn-primary my-2" @click="onClickSetting(index_token)">変更❗</button>
              </div>
              <div v-else>
                  <button class="btn btn-secondary my-2" disabled>変更❗</button>
              </div>
          </div>           
        </template>
        <template v-else-if="moderadio == 'batchlock'">
          <!-- 一括ロック -->
          <div v-for="tokenid in unlockedTokens" :key="tokenid.Object" class="nft-card-wrapper">
            <img :src="tokenid.image" class="shadow p-1 mb-3 bg-white rounded imagebox" :id="`image${array_tokenid.indexOf(tokenid)}`">
            <div class="box h6">{{tokenid.title}}</div>
            
            <!-- チェックボックス -->
            <div class="checkbox-container">
              <input type="checkbox" v-model="lockednft_2[array_tokenid.indexOf(tokenid)]" :id="'cb' + array_tokenid.indexOf(tokenid)" @change="onCheckCahange_2()"/>
            </div>
            <div class="checkbox-label">
              <label class="h6" :for="'cb' + array_tokenid.indexOf(tokenid)">{{lockedchange_string_2[array_tokenid.indexOf(tokenid)]}}</label>
            </div>
          </div>
        </template>
        <template v-else-if="moderadio == 'batchrelease'">
          <!-- 一括解除 -->
          <div v-for="tokenid in lockedTokens" :key="tokenid.Object" class="nft-card-wrapper">
            <img :src="tokenid.image" class="shadow p-1 mb-3 bg-white rounded imagebox" :id="`image${array_tokenid.indexOf(tokenid)}`">
            <div class="box h6">{{tokenid.title}}</div>
            
            <!-- チェックボックス -->
            <div class="checkbox-container">
              <input type="checkbox" v-model="lockednft_3[array_tokenid.indexOf(tokenid)]" :id="'cb' + array_tokenid.indexOf(tokenid)" @change="onCheckCahange_3()"/>
            </div>
            <div class="checkbox-label">
              <label class="h6" :for="'cb' + array_tokenid.indexOf(tokenid)">{{lockedchange_string_3[array_tokenid.indexOf(tokenid)]}}</label>
            </div>
          </div>
        </template>
        <!-- ぱんだロック率表記 -->
        <template v-else>
          <div class="info-section">
            <div class="info-card">
              <h3>あなたの現在の ぱんだポイント🏆</h3>
              <h4 class="point-value">{{pandaPoint}} ポイント</h4>
              <div class="info-note">※1つのAPPを1日ロックすると1ポイント加算されます（複数ロックは重複で加算）</div>
              <div class="info-note">※ポイントの使い道は随時「公式アカウント」から発表されるのでお見逃しなく♫</div>
            </div>

            <div class="info-card">
              <h3>ぱんだロック率の推移📈</h3>
              <h4 class="lock-rate">本日：{{pandaLock[0]}} %</h4>
              <line-chart class="linechart" :chart-data="datacollection"></line-chart>
              <div class="info-note">※運営保有分を抜いた率となります</div>
              <div class="info-note">※日本時間0:00頃に集計しています</div>
            </div>
          </div>
        </template>    
      </div> 

      <!-- 一括ボタンの表示 -->
      <template v-if="moderadio == 'normal' || moderadio == 'info'">
        <!-- 何も表示しない -->
      </template>
      <template v-else-if="moderadio == 'batchlock' && loading == false">
        <!-- 一括ロック設定ボタン -->
        <div class="batch-button-container">
          <button class="btn btn-primary" @click="onClickSetting_2()" v-if="enableGo_2">一括ロック❗</button>
          <button class="btn btn-secondary" disabled v-else>一括ロック❗</button>
        </div>
      </template>
      <template v-else-if="moderadio == 'batchrelease' && loading == false">
        <!-- 一括解除設定ボタン -->
        <div class="batch-button-container">
          <button class="btn btn-primary" @click="onClickSetting_3()" v-if="enableGo_3">一括解除❗</button>
          <button class="btn btn-secondary" disabled v-else>一括解除❗</button>
        </div>
      </template>
    </template>

    <br/><br/>
    
    



</div>
</template>

<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // script -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import { ethers } from "ethers";
import axios from 'axios'
import LineChart from './LineChart.js'

//const BASE_API_URL = "https://express.japaneast.cloudapp.azure.com/";
const BASE_API_URL = "https://asia-northeast1-aopanda-party-mint-thanks.cloudfunctions.net/api/";
// const BASE_API_URL = "http://127.0.0.1:5001/aopanda-party-mint-thanks/asia-northeast1/api/";

const SIG_API_URL = BASE_API_URL + "OffchainSig/";
const TOTAL_API_URL = BASE_API_URL + "locktotal/";
const POINT_API_URL = BASE_API_URL + "stakeinfo?address=";

// ビルド識別子（ブラウザのconsoleで古いキャッシュかどうかを見分ける用）
const BUILD_ID = "2026-09-19.2";
// Ethereum メインネットのチェーンID
const MAINNET_CHAIN_ID = '0x1';
// チェーンIDを '0x1' 形式に正規化する（'1' や '0x01'、数値にも対応）
const normalizeChainId = (id) => {
  if (id === null || id === undefined) return null;
  if (typeof id === 'number') return '0x' + id.toString(16);
  const s = String(id).trim().toLowerCase();
  if (/^0x[0-9a-f]+$/.test(s)) return '0x' + parseInt(s, 16).toString(16);
  if (/^[0-9]+$/.test(s)) return '0x' + parseInt(s, 10).toString(16);
  return s;
};

// get連続用のタイマー（opensea 429対策）
const sleep = waitTime => new Promise( resolve => setTimeout(resolve, waitTime) );

// Alchemy NFT API v3（旧 alchemy-sdk 2.x は v2 形式のレスポンスを前提としており、現在は落ちるため直接呼ぶ）
const ALCHEMY_NFT_API = "https://eth-mainnet.g.alchemy.com/nft/v3/" + process.env.VUE_APP_ALCHEMY_API_KEY;
// 並列数を抑えて map する
async function mapLimit(items, limit, fn) {
  const out = new Array(items.length);
  let next = 0;
  const worker = async () => {
    while (next < items.length) { const i = next++; out[i] = await fn(items[i], i); }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return out;
}
// NFT1件分のメタデータから表示用の name / image を取り出す
function pickNftDisplay(nft, tokenId) {
  const raw = (nft && nft.raw) || {};
  const meta = raw.metadata || {};
  const img = (nft && nft.image) || {};
  let image = meta.image || img.cachedUrl || img.originalUrl || "";
  if (!image && nft && typeof nft.tokenUri === 'string') {
    // このコレクションは tokenURI(.../metadata/{id}.json) と画像(.../images/{id}.gif) が同じ規則で並んでいる
    const m = nft.tokenUri.match(/^(https?:\/\/.+)\/metadata\/(\d+)\.json$/);
    if (m) image = m[1] + "/images/" + m[2] + ".gif";
  }
  const name = (nft && nft.name) || meta.name || ("#" + tokenId);
  return { name, image, complete: !!((nft && nft.name) || meta.name) && !!(meta.image || img.cachedUrl || img.originalUrl) };
}
// NFTメタデータをまとめて取得する（100件ずつ）。戻り値は tokenId(10進文字列) → NFT
async function fetchNftMetadataBatch(contractAddress, tokenIds, refreshCache) {
  const result = {};
  for (let i = 0; i < tokenIds.length; i += 100) {
    const chunk = tokenIds.slice(i, i + 100);
    const res = await axios.post(ALCHEMY_NFT_API + "/getNFTMetadataBatch", {
      tokens: chunk.map(tokenId => ({ contractAddress, tokenId })),
      refreshCache: !!refreshCache,
    });
    for (const nft of (res.data && res.data.nfts) || []) {
      if (nft && nft.tokenId != null) result[String(nft.tokenId)] = nft;
    }
  }
  return result;
}
// まず通常取得し、名前や画像が欠けているトークン（ロック/解除直後などでAlchemy未キャッシュ）だけ再取得する
async function fetchNftMetadata(contractAddress, tokenIds) {
  const result = await fetchNftMetadataBatch(contractAddress, tokenIds, false);
  const missing = tokenIds.filter(id => !pickNftDisplay(result[id], id).complete);
  if (missing.length > 0) {
    console.log("metadata missing for", missing.length, "tokens; refreshing");
    try {
      const refreshed = await fetchNftMetadataBatch(contractAddress, missing, true);
      for (const id of Object.keys(refreshed)) {
        if (pickNftDisplay(refreshed[id], id).complete || !result[id]) result[id] = refreshed[id];
      }
    } catch (e) {
      console.log("metadata refresh failed:", e);
    }
  }
  return result;
}

export default {
  components: {
      LineChart
  },
  data(){
      return{
        connect:null,
        hasProvider:false,   // ウォレットのProviderが見つかっているか（Provider本体は this.ethereum に非リアクティブで保持）
        connectError:"",     // 接続失敗時にボタン下へ出すメッセージ
        loading:false,
        //! APPのコントラクトアドレス
        nft_contractAddress: "0xC7e4D1DfB2FFdA31F27c6047479dFA7998a07d47", 
        //! StakeMagnageのコントラクトアドレス※切り替え時に変更する！ 
        stake_contractAddress:"0x473f38CA2C7883E7346027e2AAAdEFe32B227A51",
        networkchange:false,

        toggled:1,

        array_tokenid:[],
        havenft:[],

        const_lockednft:[],
        lockednft:[],
        lockedchange:[],
        lockedchange_string:[],

        lockednft_2:[],
        lockedchange_2:[],
        lockedchange_string_2:[],
        enableGo_2:false,

        lockednft_3:[],
        lockedchange_3:[],
        lockedchange_string_3:[],
        enableGo_3:false,

        moderadio:'normal',

        // ぱんだロック
        pandaLock:[],
        datacollection: null,
        pandaPoint:0,
        pandaPoint_now:0,
        pandaPoint_history:0,
        pandaPoint_rank:0,  // 0:bronze,1:silver,2:gold,3:platium,4:diamond
        pandaPoint_rank_name:"ブロンズ",
      }
  },
  created () {
      // ウォレットのProviderはVueに監視させない（data()に入れるとProvider内部まで書き換えられてしまう）
      this.ethereum = undefined;
      this._announcedProviders = [];   // EIP-6963 で告知されたウォレット
      this._eventsBoundTo = null;      // イベント購読中のProvider
      this._connecting = false;        // onClickConnect 実行中フラグ（二重実行防止）
      this._chainId = null;            // 最後に確認したチェーンID
  },
  async mounted () {
      console.log("PandaLock build", BUILD_ID);
      // 複数ウォレット同居時は MetaMask を優先して拾う（EIP-6963）。無ければ window.ethereum
      this.discoverProviders();
      this.setProvider(this.pickProvider());
      console.log("this.ethereum:",this.ethereum)
      // 既に許可済みのサイトなら、ポップアップ無しで接続状態を復元する（リロードしても接続画面に戻らない）
      await this.tryRestoreSession();
  },
  methods: {
    // EIP-6963: ブラウザ拡張にプロバイダの告知を要求する
    discoverProviders () {
      if (typeof window === 'undefined') return;
      window.addEventListener('eip6963:announceProvider', (event) => {
        const detail = event && event.detail;
        if (!detail || !detail.provider) return;
        if (this._announcedProviders.some(d => d.provider === detail.provider)) return;
        this._announcedProviders.push(detail);
        // 接続前なら、より適切なプロバイダに差し替える
        if (this.connect == null && !this._connecting) {
          this.setProvider(this.pickProvider());
        }
      });
      window.dispatchEvent(new Event('eip6963:requestProvider'));
    },
    // 使うプロバイダを決める: MetaMask(EIP-6963) > window.ethereum.providers内のMetaMask > window.ethereum > 他の告知ウォレット
    pickProvider () {
      const announced = this._announcedProviders || [];
      const metamask = announced.find(d => d.info && d.info.rdns === 'io.metamask');
      if (metamask) return metamask.provider;
      const injected = (typeof window !== 'undefined') ? window.ethereum : undefined;
      if (injected && Array.isArray(injected.providers) && injected.providers.length > 0) {
        return injected.providers.find(p => p && p.isMetaMask) || injected.providers[0];
      }
      if (injected) return injected;
      if (announced.length > 0) return announced[0].provider;
      return undefined;
    },
    setProvider (provider) {
      this.ethereum = provider;
      this.hasProvider = !!(provider && typeof provider.request === 'function');
      this.bindProviderEvents();
    },
    // chainChanged / accountsChanged を購読する（Providerが変わったら付け替える）
    bindProviderEvents () {
      const p = this.ethereum;
      if (!p || typeof p.on !== 'function' || this._eventsBoundTo === p) return;
      const prev = this._eventsBoundTo;
      if (prev && typeof prev.removeListener === 'function') {
        prev.removeListener('chainChanged', this.onChainChanged);
        prev.removeListener('accountsChanged', this.onAccountsChanged);
      }
      p.on('chainChanged', this.onChainChanged);
      p.on('accountsChanged', this.onAccountsChanged);
      this._eventsBoundTo = p;
    },
    // ウォレット側でチェーンが変わった（自分で要求した切り替えの通知も来る）
    onChainChanged (chainId) {
      const id = normalizeChainId(chainId);
      console.log("chainChanged:", id);
      if (this._connecting || id === this._chainId) return;  // 接続処理中 or 既知のチェーンなら何もしない
      this._chainId = id;
      if (id === MAINNET_CHAIN_ID) {
        this.networkchange = false;
        if (this.connect != null) this.onClickConnect();      // メインネットに戻ったら再読込
      } else if (this.connect != null) {
        // 接続中にメインネット以外へ切り替えられた → 接続画面に戻して案内
        this.resetConnection();
        this.networkchange = true;
      }
    },
    // ウォレット側でアカウントが変わった（接続直後にも通知が来る）
    onAccountsChanged (accounts) {
      const next = (accounts && accounts[0]) ? String(accounts[0]).toLowerCase() : null;
      const current = this.connect ? String(this.connect).toLowerCase() : null;
      console.log("accountsChanged:", next);
      if (this._connecting || next === current) return;
      if (next === null) {               // ロック or 接続解除
        this.resetConnection();
        return;
      }
      if (this.connect != null) this.onClickConnect();  // 別アカウントに切り替わった → 再読込
    },
    // 接続状態を初期化して接続画面へ戻す
    resetConnection () {
      this.connect = null;
      this.loading = false;
      this.havenft = [];
      this.const_lockednft = [];
      this.array_tokenid.splice(0);
    },
    // 既に許可済みのサイトなら、ポップアップを出さずに接続状態を復元する
    async tryRestoreSession () {
      if (!this.hasProvider) return;
      try {
        const accounts = await this.ethereum.request({ method: 'eth_accounts' });
        if (!accounts || accounts.length === 0) return;
        const chainId = normalizeChainId(await this.ethereum.request({ method: 'eth_chainId' }));
        this._chainId = chainId;
        if (chainId !== MAINNET_CHAIN_ID) return;   // ここでは切り替え要求（ポップアップ）を出さない
        console.log("restore session for", accounts[0]);
        await this.onClickConnect();
      } catch (e) {
        console.log("restore session skipped:", e);
      }
    },
    // 接続後にチェーンを確認する。メインネット以外なら切り替えを要求し、最終的にメインネットなら true
    async ensureMainnet () {
      let chainId = normalizeChainId(await this.ethereum.request({ method: 'eth_chainId' }));
      console.log("chainId:", chainId);
      this._chainId = chainId;
      if (chainId === MAINNET_CHAIN_ID) return true;
      try {
        await this.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: MAINNET_CHAIN_ID }],
        });
      } catch (e) {
        console.log("wallet_switchEthereumChain rejected/failed:", e);  // ユーザーが拒否など
        return false;
      }
      chainId = normalizeChainId(await this.ethereum.request({ method: 'eth_chainId' }));
      console.log("chainId after switch:", chainId);
      this._chainId = chainId;
      return chainId === MAINNET_CHAIN_ID;
    },
    // 接続エラーを画面表示用の文言にする
    describeConnectError (e) {
      const code = e && e.code;
      if (code === 4001) return "ウォレットで接続がキャンセルされました。もう一度「ウォレット接続する」を押して承認してください";
      if (code === -32002) return "ウォレットが確認待ちです。MetaMaskのポップアップ（拡張機能アイコン）を開いて承認してください";
      const msg = (e && (e.message || e.reason)) ? String(e.message || e.reason) : String(e);
      return "ウォレット接続に失敗しました: " + msg.slice(0, 120);
    },

    async onClickConnect () {
      if (this._connecting) return;   // 二重実行防止
      this._connecting = true;
      try {
        await this.connectAndLoad();
      } finally {
        this._connecting = false;
      }
    },

    async connectAndLoad () {
      this.connectError = "";
      if (this.connect == null) {
        this.setProvider(this.pickProvider());
      }
      console.log("this.ethereum:",this.ethereum)
      if (!this.hasProvider) {
        return;
      }

      // 1. まず接続してアカウントを取得する
      //    以前は接続前に window.ethereum.chainId が '0x1' であることを要求していたが、
      //    MetaMask はサイトごとにネットワークを持つ方式になり、未接続サイトには
      //    ウォレット内部の「最後に選んだネットワーク」を返す。接続しないとサイトの
      //    ネットワークを変えられないため、メインネット以外だと永久に接続できなかった。
      let account = null;
      try {
        const accounts = await this.ethereum.request({ method: 'eth_requestAccounts' });
        account = (accounts && accounts.length > 0) ? accounts[0] : null;
      } catch (e) {
        console.log("eth_requestAccounts rejected:", e);  // ユーザーが拒否など
        this.connectError = this.describeConnectError(e);
      }
      if (!account) {
        return;
      }

      // 2. 接続後にチェーンを確認し、メインネット以外なら切り替えを要求する
      let onMainnet = false;
      try {
        onMainnet = await this.ensureMainnet();
      } catch (e) {
        console.log("chain check failed:", e);
      }
      if (!onMainnet) {
        this.networkchange = true;
        return;
      }
      this.networkchange = false;
      console.log("connected");

      this.connect = account
      console.log("walletaddress:",this.connect)

      this.loading = true;
      try {
        await this.loadWalletData();
      } catch (e) {
        console.log("loadWalletData failed:", e);  // API障害などで「Please wait...」のまま固まらないようにする
      } finally {
        this.loading = false;
      }
      await this.$nextTick();
      try {
        await this.refreshDisplay();
      } catch (e) {
        console.log("refreshDisplay failed:", e);
      }
      await sleep( 1000 );  // 描画遅延対策
    },

    // 現在のモードに合わせて枠線や「変更」「一括」ボタンの状態を更新する（ロック/解除後の再読込でも呼ばれる）
    async refreshDisplay () {
      if (this.moderadio === 'batchlock') await this.changedisplay_2();
      else if (this.moderadio === 'batchrelease') await this.changedisplay_3();
      else if (this.moderadio === 'normal') await this.changedisplay();
    },

    // 保有しているAPPとロック情報、ロック率、ぱんだポイントを取得する（接続後に呼ぶ）
    async loadWalletData () {
        //保有しているAPPとロック情報を取得------
        let readOnlyContract = null;
        try{
          // --ここからethers
          const provider = new ethers.providers.Web3Provider(this.ethereum) // 選択されたネットワークで繋ぐ
          // const bn = await provider.getBlockNumber()
          const abi = require("../contracts/abi.json");  // JSONはそのまま読み込んで使う（.abiとか不要！）
          readOnlyContract = new ethers.Contract(this.nft_contractAddress, abi,provider); // 読み込みだけならこれつかえばOK
          // tokensOfOwner実行
          this.havenft = await readOnlyContract.tokensOfOwner(this.connect);
          console.log('this.havenft',this.havenft);

          // getLockState実行
          this.const_lockednft = await readOnlyContract.getStakeStateOfOwner(this.connect);
          this.lockednft = JSON.parse(JSON.stringify(this.const_lockednft)); 
          console.log('this.lockednft',this.lockednft);

          for(let i =0; i < this.const_lockednft.length;i++){
            this.lockedchange[i] = false;
            if(this.lockednft[i] == true){
              this.lockedchange_string[i] = "ロック";
            }else{
              this.lockedchange_string[i] = "解除";
            }
          }

          this.lockednft_2 = JSON.parse(JSON.stringify(this.lockednft));
          this.lockednft_3 = JSON.parse(JSON.stringify(this.lockednft));
          
          // 一括ロック・解除用の文字列も初期化
          this.lockedchange_string_2 = new Array(this.const_lockednft.length);
          this.lockedchange_string_3 = new Array(this.const_lockednft.length);
          for(let i = 0; i < this.const_lockednft.length; i++) {
            if(this.lockednft_2[i] == true){
              this.lockedchange_string_2[i] = "ロック";
            }else{
              this.lockedchange_string_2[i] = "解除";
            }
            if(this.lockednft_3[i] == true){
              this.lockedchange_string_3[i] = "ロック";
            }else{
              this.lockedchange_string_3[i] = "解除";
            }
          }

          // -- ここまでethers
        } catch(e){
          console.log(e);  //metamaskで拒否など
        }


        // -----------------------------------
        // 保有しているAPPの情報取得（havenft と同じ順番で array_tokenid に入れる）
        this.array_tokenid.splice(0); //clear
        const tokenIds = this.havenft.map(t => ethers.BigNumber.from(t).toString());
        let metadataById = {};
        try {
          metadataById = await fetchNftMetadata(this.nft_contractAddress, tokenIds);
        } catch (e) {
          console.log("metadata fetch failed; falling back to on-chain tokenURI:", e);  // Alchemy障害でも一覧は出す
        }
        // Alchemy に無いトークンは、チェーン上の tokenURI から画像URLを組み立てる（ロック/解除直後はURIが切り替わる）
        const noImage = tokenIds.filter(id => !pickNftDisplay(metadataById[id], id).image);
        if (noImage.length > 0 && readOnlyContract) {
          console.log("no image for", noImage.length, "tokens; reading tokenURI on-chain");
          const uris = await mapLimit(noImage, 8, id => readOnlyContract.tokenURI(id).catch(() => null));
          noImage.forEach((id, i) => {
            if (uris[i]) metadataById[id] = Object.assign({}, metadataById[id] || {}, { tokenUri: uris[i] });
          });
        }
        for (const tokenId of tokenIds) {
          const d = pickNftDisplay(metadataById[tokenId], tokenId);
          this.array_tokenid.push({ id: tokenId, title: d.name, image: d.image });
        }

        // ぱんだロック率取得
        const response = await axios.get(TOTAL_API_URL);
        console.log("pandalock-response.data:",response);
        var templock = response.data.split(',');
        //console.log("templock:",templock);

        for(let i=0;i < 8;i++){
          this.pandaLock[i] = Math.round((Number(templock[i]) / 7440) * 100 *100) /100;
        }
        //console.log("pandalock:",this.pandaLock);
        
        var now = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000));
        //console.log("now:",now);
        var chartday = new Array(8);
        for(let i=0;i<8;i++){
          chartday[i] = new Date();
          chartday[i].setDate(now.getDate() - (i));
        }
        
        this.datacollection = {
          labels: [(chartday[7].getMonth() + 1) + "/" +  chartday[7].getDate(),
                    (chartday[6].getMonth() + 1) + "/" +  chartday[6].getDate(),
                    (chartday[5].getMonth() + 1) + "/" +  chartday[5].getDate(),
                    (chartday[4].getMonth() + 1) + "/" +  chartday[4].getDate(),
                    (chartday[3].getMonth() + 1) + "/" +  chartday[3].getDate(),
                    (chartday[2].getMonth() + 1) + "/" +  chartday[2].getDate(),
                    (chartday[1].getMonth() + 1) + "/" +  chartday[1].getDate(),
                    (chartday[0].getMonth() + 1) + "/" +  chartday[0].getDate()],
          datasets: [
            {
              label: 'ロック率',
              backgroundColor: '#00FF69',
              data: [this.pandaLock[7],this.pandaLock[6],this.pandaLock[5],this.pandaLock[4],this.pandaLock[3],
                    this.pandaLock[2],this.pandaLock[1],this.pandaLock[0]]
            }
          ]
        }

        // this.option = {
        //   scales: {
        //     yAxes: [{
        //       ticks: {
        //         min: Math.min(...this.datacollection.datasets[0].data) * 0.8, // your minimum value
        //         max: Math.max(...this.datacollection.datasets[0].data) * 1.2, // your maximum value
        //       }
        //     }]
        //   },
        //   responsive: true,
        //   maintainAspectRatio: false
        // }

        // ぱんだポイント
        const point_response = await axios.get(POINT_API_URL + this.connect);
        console.log("point_response.data:",point_response);
        if(point_response.data != ""){ //新規ウォレットで購入した場合は取得できない
          var pointJson = point_response.data;
          console.log("pointJson:",pointJson);
          this.pandaPoint = Math.floor(Number(pointJson["total"]) / (60*60*24));
          //this.pandaPoint_now = Math.floor(Number(pointJson["now"]) / (60*60*24));
          //this.pandaPoint_history = Math.floor(Number(pointJson["history"]) / (60*60*24));
          //this.pandaPoint = this.pandaPoint_now + this.pandaPoint_history
          console.log("pandaPoint:",this.pandaPoint);
          //console.log("pandaPoint_now:",this.pandaPoint_now);
          //console.log("pandaPoint_history:",this.pandaPoint_history);

          // ポイントによってランクが決まる
          if(this.pandaPoint > 1000){
            this.pandaPoint_rank = 1;
            this.pandaPoint_rank_name = "シルバー";
          }else if(this.pandaPoint > 2000){
            this.pandaPoint_rank = 2;
            this.pandaPoint_rank_name = "ゴールド";
          }
          else if(this.pandaPoint > 3000){
            this.pandaPoint_rank = 3;
            this.pandaPoint_rank_name = "プラチナ";
          }
          else if(this.pandaPoint > 40){
            this.pandaPoint_rank = 4;
            this.pandaPoint_rank_name = "ダイアモンド";
          }else{
            // bronze
          }
        }
    },

    // 個別ロック/解除を実行
    async onClickSetting(index){
      this.loading = true;
      const set_tokenId = ethers.BigNumber.from(this.havenft[index]).toNumber();
      console.log('set_tokenId',set_tokenId);
      const set_val = this.lockednft[index];
      console.log('set_val',set_val);

      try{
        const provider = new ethers.providers.Web3Provider(this.ethereum)
        const abi = require("../contracts/abi_stake.json");
        const signer = provider.getSigner() ;
        const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

        // Lock設定変更を実行
        let tx;
        if(set_val == true){
          tx = await contract.setStartStake(set_tokenId);
        }else{
          // TimeStamp生成
          var date = new Date();
          console.log('date',date);
          var effectiveDate = Math.floor(date.setHours(date.getUTCDate() + 24) / 1000 );
          console.log('effectiveDate',effectiveDate);
          const coupon = await axios.post(SIG_API_URL,{
                                                  tokenid:set_tokenId,
                                                  time:effectiveDate,
                                                  address:this.connect.toString()
                                                },
                                                {
                                                  'Content-Type': 'application/json',
                                                  'Access-Control-Allow-Origin': '*'
                                                });
          //console.log('coupon',coupon);
          tx = await contract.setEndStake(set_tokenId,effectiveDate,coupon.data);
        }
        
        const result = await tx.wait();
        console.log('seted',result.gasUsed.toNumber());

        //! 切り替え
        // OpenSeaの更新は不要となったのでコメントアウト
        //await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(set_tokenId)+ '/?force_update=true')
        //await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(set_tokenId) + '/?force_update=true')
              // .then(function (response) {
              //   console.log(response.data);
              // })
      }catch(e){
        console.log(e);  //metamaskで拒否など
      }

      await this.onClickConnect();
      this.loading = false;
    },

    // 一括ロックを実行
    async onClickSetting_2(){
      this.loading = true;
      var lockarray= new Array();
      var set_tokenId;
      for(var i =0; i <this.lockednft_2.length;i++){
        if(this.lockednft_2[i] == true && this.const_lockednft[i] == false){
          set_tokenId = ethers.BigNumber.from(this.havenft[i]).toNumber();
          lockarray.push(set_tokenId);
          console.log('set_tokenId',set_tokenId);
        }
      }

      try{
        const provider = new ethers.providers.Web3Provider(this.ethereum)
        const abi = require("../contracts/abi_stake.json");
        const signer = provider.getSigner() ;
        const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

        // Lock設定変更を実行
        let tx = await contract.setStartStakeArray(lockarray);      
        const result = await tx.wait();
        console.log('array_seted',result.gasUsed.toNumber());

        // OpenSeaの更新は不要となったのでコメントアウト
        // for(var j = 0;j < lockarray.length;j++){
        //   //! 切り替え
        //   await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
        //   //await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
        //       .then(function (response) {
        //         console.log(response.data);
        //       })
        //   await sleep( 500 );
        // }
      }catch(e){
        console.log(e);  //metamaskで拒否など
      }

      await this.onClickConnect();
      this.loading = false;
    },

    // 一括解除を実行
    async onClickSetting_3(){
      this.loading = true;
      var lockarray= new Array();
      var set_tokenId;
      for(var i =0; i <this.lockednft_3.length;i++){
        if(this.lockednft_3[i] == false && this.const_lockednft[i] == true){
          set_tokenId = ethers.BigNumber.from(this.havenft[i]).toNumber();
          lockarray.push(set_tokenId);
          console.log('set_tokenId',set_tokenId);
        }
      }

      try{
        const provider = new ethers.providers.Web3Provider(this.ethereum)
        const abi = require("../contracts/abi_stake.json");
        const signer = provider.getSigner() ;
        const contract = new ethers.Contract(this.stake_contractAddress, abi, signer);

        // Lock設定変更を実行
        // TimeStamp生成
        var date = new Date();
        console.log('date',date);
        var effectiveDate = Math.floor(date.setHours(date.getUTCDate() + 24) / 1000 );
        console.log('effectiveDate',effectiveDate);

        var effectiveDateList = new Array();
        var couponList = new Array();
        for(var n=0; n < lockarray.length;n++){
          effectiveDateList[n] = effectiveDate;
          //console.log('effectiveDateList',effectiveDateList);
          const coupon = await axios.post(SIG_API_URL,{
                                                  tokenid:lockarray[n],
                                                  time:effectiveDate,
                                                  address:this.connect.toString()
                                                },
                                                {
                                                  'Content-Type': 'application/json',
                                                  'Access-Control-Allow-Origin': '*'
                                                });
          //console.log('coupon',coupon);
          couponList[n] = coupon.data;
          //console.log('couponList',couponList);
        }

        //console.log('lockarray',lockarray);
        //console.log('effectiveDateList',effectiveDateList);
        //console.log('couponList',couponList);

        var tx = await contract.setEndStakeArray(lockarray,effectiveDateList,couponList);    
        const result = await tx.wait();
        console.log('array_seted',result.gasUsed.toNumber());

        // OpenSeaの更新は不要となったのでコメントアウト
        // for(var j = 0;j < lockarray.length;j++){
        //   //! 切り替え
        //   await axios.get('https://api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
        //   //await axios.get('https://testnets-api.opensea.io/api/v1/asset/' + this.nft_contractAddress + '/' + String(lockarray[j]) + '/?force_update=true')
        //       .then(function (response) {
        //         console.log(response.data);
        //       })
        //   await sleep( 500 );
        // }
      }catch(e){
        console.log(e);  //metamaskで拒否など
      }

      await this.onClickConnect();
      this.loading = false;
    },

    // 個別管理
    async onModeCahange(){  //モード切替
      console.log('onModeCahange');
      this.toggled = 1;
      this.$nextTick(function() {
        this.changedisplay();
      })
    },
    async onCheckCahange(){ // チェック変更
      console.log('onCheckCahange');
      await this.changedisplay();
    },
    async changedisplay(){
      for(let i =0; i < this.const_lockednft.length;i++){
        if(this.const_lockednft[i] != this.lockednft[i]){
          this.lockedchange[i] = true;
          // console.log('change-check:true' + i,this.lockedchange[i]);
        }else{
          this.lockedchange[i] = false;
          // console.log('change-check:false' + i,this.lockedchange[i]);
        }

        var elem = document.querySelector('#image' + String(i));
        if(this.lockednft[i] == true){
          this.lockedchange_string[i] = "ロック";
          if (elem) elem.style.border = "5px dotted #FF0000";
        }else{
          this.lockedchange_string[i] = "解除";
          if (elem) elem.style.border = "none";
        }
      }
    },
    // 一括ロック
    async onModeCahange_2(){  //モード切替
      console.log('onModeCahange_2');
      this.toggled = 2;
      this.$nextTick(function() {
        this.changedisplay_2();
      })
    },
    async onCheckCahange_2(){ // チェック変更
      console.log('onCheckCahange_2');
      await this.changedisplay_2();
    },
    async changedisplay_2(){
      var enable = false;
      for(let i =0; i < this.const_lockednft.length;i++){
        if(this.const_lockednft[i] == false){
          if(this.const_lockednft[i] != this.lockednft_2[i]){
            this.lockedchange_2[i] = true;
            enable = true;
            // console.log('change-check:true' + i,this.lockedchange[i]);
          }else{
            this.lockedchange_2[i] = false;
            // console.log('change-check:false' + i,this.lockedchange[i]);
          }

          var elem = document.querySelector('#image' + String(i));
          if(this.lockednft_2[i] == true){
            this.lockedchange_string_2[i] = "ロック";
            if (elem) elem.style.border = "5px dotted #FF0000";
          }else{
            this.lockedchange_string_2[i] = "解除";
            if (elem) elem.style.border = "none";
          }
        }
      }

      if(enable == true){
        this.enableGo_2 = true;
      }else{
        this.enableGo_2 = false;
      }
    },

    // 一括解除
    async onModeCahange_3(){  //モード切替
      console.log('onModeCahange_3');
      this.toggled = 3;
      this.$nextTick(function() {
        this.changedisplay_3();
      })
    },
    async onCheckCahange_3(){  // チェック変更
      console.log('onCheckCahange_3');
      await this.changedisplay_3();
    },
    async changedisplay_3(){
      var enable = false;
      for(let i =0; i < this.const_lockednft.length;i++){
        if(this.const_lockednft[i] == true){
          if(this.const_lockednft[i] != this.lockednft_3[i]){
            this.lockedchange_3[i] = true;
            enable = true;
            // console.log('change-check:true' + i,this.lockedchange[i]);
          }else{
            this.lockedchange_3[i] = false;
            // console.log('change-check:false' + i,this.lockedchange[i]);
          }

          var elem = document.querySelector('#image' + String(i));
          if(this.lockednft_3[i] == true){
            this.lockedchange_string_3[i] = "ロック";
            if (elem) elem.style.border = "5px dotted #FF0000";
          }else{
            this.lockedchange_string_3[i] = "解除";
            if (elem) elem.style.border = "none";
          }
        }
      }

      if(enable == true){
        this.enableGo_3 = true;
      }else{
        this.enableGo_3 = false;
      }
    },
    // ロック情報
    async onModeCahange_4(){  //モード切替
      console.log('onModeCahange_4');
      this.toggled = 4;
      
      
    },


    // ブラウザでメタマスクが使える状態かどうかを返す
    canUseMetaMask () {
      // console.log(this.ethereum)
      return this.hasProvider;
    },
    // メタマスクに接続されているかどうかを返す
    connectedMetaMask () {
      //console.log(this.connect)
      return this.hasProvider && this.connect != null;
    },
    // connectedTargetNetwork () {
    //   console.log(this.ethereum.chainId )
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x4';
    // },
    // connectedMaticNetwork () {
    //   return this.connectedMetaMask() && window.ethereum.chainId === '0x89';
    // },

  },
  computed: {
    unlockedTokens() {
      return this.array_tokenid.filter((_, index) => !this.const_lockednft[index]);
    },
    lockedTokens() {
      return this.array_tokenid.filter((_, index) => this.const_lockednft[index]);
    }
  },
}
</script>
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- // CSS -->
<!-- ///////////////////////////////////////////////////////////////////////////////////////// -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem;
  text-align: center;
}

h2 {
  color: #1a365d;
  font-size: 2rem;
  margin-bottom: 0.75rem;
  font-weight: 700;
}

.StatsInfoStyle {
  background: white;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.75rem;
  text-align: left;
}

.StatsInfoStyle div {
  color: #4a5568;
  font-size: 1rem;
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  transition: all 0.3s ease;
  border: none;
}

.btn-primary {
  background: #4299e1;
  color: white;
}

.btn-primary:hover {
  background: #3182ce;
  transform: translateY(-2px);
}

.btn-secondary {
  background: #a0aec0;
  color: white;
}

.btn-outline-secondary {
  border: 2px solid #a0aec0;
  color: #4a5568;
  background: white;
}

.btn-outline-secondary:hover {
  background: #a0aec0;
  color: white;
}

.btn-warning {
  background: #ed8936;
  color: white;
}

.locklogo {
  width: 200px;
  height: auto;
  margin: 0.75rem auto;
  display: block;
}

.imagebox {
  border-radius: 1rem;
  transition: transform 0.3s ease;
  margin: 1rem;
  width: 200px;
  height: 200px;
  object-fit: cover;
}

.imagebox:hover {
  transform: translateY(-5px);
}

.box {
  margin: 1rem 0;
  color: #2d3748;
}

.loader {
  display: inline-block;
  width: 80px;
  height: 80px;
  border: 6px solid #e2e8f0;
  border-radius: 50%;
  border-top-color: #4299e1;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.linechart {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin: 2rem 0;
}

input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  margin: 1rem;
  cursor: pointer;
}

hr {
  border: none;
  border-top: 2px solid #e2e8f0;
  margin: 2rem 0;
}

.btn-group {
  display: inline-flex;
  gap: 0.5rem;
  background: white;
  padding: 0.5rem;
  border-radius: 0.75rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 1rem 0;
}

.collection-detail {
  display: grid;
  grid-template-columns: repeat(auto-fit, 250px);
  gap: 1rem;
  margin-top: 0.75rem;
  justify-content: center;
  width: 100%;
}

.collection-detail > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* NFTカードのラッパー */
.nft-card-wrapper {
  width: 250px;
  padding: 1rem;
  background: white;
  border-radius: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media screen and (max-width: 768px) {
  .collection-detail {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  .nft-card-wrapper {
    width: 100%;
  }

  .container {
    padding: 1rem;
  }
  
  h2 {
    font-size: 1.5rem;
  }
  
  .btn-group {
    flex-direction: column;
    width: 100%;
  }
  
  .btn {
    width: 100%;
    margin: 0.25rem 0;
  }
}

/* ロック情報セクションのスタイル */
.info-section {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-card {
  background: white;
  padding: 1rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.info-card h3 {
  color: #1a365d;
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  font-weight: 700;
}

.point-value {
  font-size: 2rem;
  font-weight: bold;
  color: #FF0000;
  margin: 1rem 0;
}

.lock-rate {
  font-size: 1.5rem;
  font-weight: bold;
  color: #FF0000;
  margin: 1rem 0;
}

.info-note {
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0.5rem 0;
}

.linechart {
  margin: 2rem auto;
  max-width: 100%;
}

@media screen and (max-width: 768px) {
  .info-card {
    padding: 1rem;
  }

  .info-card h3 {
    font-size: 1.25rem;
  }

  .point-value {
    font-size: 1.5rem;
  }

  .lock-rate {
    font-size: 1.25rem;
  }
}

/* ボタンセクションのスタイル */
.connect-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin: 0.75rem 0;
}

.connect-button {
  min-width: 200px;
  margin: 0.5rem 0;
}

.batch-button-container {
  display: flex;
  justify-content: center;
  margin: 0.75rem 0;
}

.batch-button-container .btn {
  min-width: 200px;
}

/* 既存のw-180pxクラスを上書き */
.w-180px {
  width: auto !important;
  min-width: 180px;
}

.checkbox-container {
  display: flex;
  justify-content: center;
  margin: 0.5rem 0;
}

.checkbox-label {
  text-align: center;
  margin-bottom: 0.5rem;
}

input[type="checkbox"] {
  width: 1.5rem;
  height: 1.5rem;
  margin: 0;
  cursor: pointer;
}
</style>
